export const PLAN_SLUGS = {
  TRIAL: 'trial',
  ANALYSIS: 'analysis',
  PRO: 'pro',
};

const env = import.meta.env || {};

export const SHOW_LAUNCH_PROMO = String(env.VITE_SHOW_LAUNCH_PROMO || '').toLowerCase() === 'true';

export const PLANS = {
  trial: {
    slug: PLAN_SLUGS.TRIAL,
    name: 'Essai gratuit',
    priceLabel: env.VITE_TRIAL_PRICE_LABEL || '0 $',
    interval: null,
    analysisLimit: 3,
    cta: 'Commencer gratuitement',
    description: 'Idéal pour tester ImmoIQ avec vos premières analyses.',
    features: [
      '3 analyses gratuites',
      'Calcul de rentabilité de base',
      'Sauvegarde limitée',
      'Idéal pour tester ImmoIQ',
    ],
  },
  analysis: {
    slug: PLAN_SLUGS.ANALYSIS,
    name: 'Analyse',
    priceLabel: env.VITE_ANALYSIS_PRICE_LABEL || '10 $/mois',
    interval: 'month',
    cta: 'Choisir Analyse',
    description: 'Les outils essentiels pour analyser vos immeubles.',
    features: [
      'Analyses immobilières',
      'Sauvegarde des immeubles',
      'Calcul de cashflow',
      'Mise de fonds estimée',
      'Ratios de rentabilité',
      'Scénarios de taux d’intérêt',
    ],
  },
  pro: {
    slug: PLAN_SLUGS.PRO,
    name: 'Pro',
    priceLabel: env.VITE_PRO_PRICE_LABEL || '45 $/mois',
    interval: 'month',
    cta: 'Choisir Pro',
    recommended: true,
    description: 'Pour les investisseurs qui veulent comparer, projeter et piloter.',
    features: [
      'Analyses illimitées',
      'Comparaison de scénarios',
      'Rapports détaillés',
      'Projections avancées',
      'Tableau de bord investisseur',
      'Fonctionnalités futures incluses',
    ],
  },
};

export const PLAN_ORDER = [PLAN_SLUGS.TRIAL, PLAN_SLUGS.ANALYSIS, PLAN_SLUGS.PRO];
export const PAID_PLAN_SLUGS = [PLAN_SLUGS.ANALYSIS, PLAN_SLUGS.PRO];

export function normalizePlanSlug(value) {
  const raw = String(value || '').toLowerCase().trim();
  if (!raw || raw === 'free' || raw === 'gratuit' || raw === 'base') return PLAN_SLUGS.TRIAL;
  if (raw === 'plus' || raw === 'investisseur' || raw === 'strategique') return PLAN_SLUGS.ANALYSIS;
  if (raw === PLAN_SLUGS.ANALYSIS || raw === PLAN_SLUGS.PRO || raw === PLAN_SLUGS.TRIAL) return raw;
  return PLAN_SLUGS.TRIAL;
}

export function getPlanConfig(planSlug) {
  return PLANS[normalizePlanSlug(planSlug)] || PLANS.trial;
}

export function getPlanLevel(planSlug) {
  const idx = PLAN_ORDER.indexOf(normalizePlanSlug(planSlug));
  return idx < 0 ? 0 : idx;
}

export function isPaidPlan(planSlug) {
  return PAID_PLAN_SLUGS.includes(normalizePlanSlug(planSlug));
}
